const customerContactForm = document.querySelector( '#gform_3' );

// Remove tabindex attributes that Gravity Forms adds.
if ( customerContactForm ) {
	const tabIndexed = document.querySelectorAll( '[tabindex]' );
	tabIndexed.forEach( tabIndex => {
		tabIndex.removeAttribute( 'tabindex' );
	});
}
